<yp-ui-notify></yp-ui-notify>
<div class="app-wrapper">
    <!-- <ex-main-header></ex-main-header> -->
    <ex-app-header></ex-app-header>
    <div id="main-scroll-top" class="app-outlet-wrapper">
        <router-outlet></router-outlet>
    </div>
    <ex-main-footer></ex-main-footer>
</div>